const ar = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'أنا أتعلم اللغة الصينية على SuperChinese. انضم ليّ!',
	'零基础任性学': 'تعلم من الصفر',
	'听说读写全面提升': 'حسّن مهارات الاستماع والتحدث والقراءة والكتابة في لغتك الصينية',
	'趣味对话': 'حوارات ممتعة',
	'100+日常对话等你来': 'أكثر من 100 محادثة عامة في انتظارك',
	'智能AI': 'الذكاء الاصطناعي',
	'个性化学习推荐，由浅入深系统学': 'توصيات تعليمية مشخصة ، وطرق تعلم منهجية',
	'趣味对话等你来': 'العديد من الحوارات الممتعة في انتظارك',
	'立即打开': 'ابدأ الآن',
	'我在SuperChinese<br />已累计学习{day}天': 'أنا استخدم SuperChinese<br />تسلسل التعلم <span>{day}</span> يوم',
	'我在SuperChinese<br />已连续学习{day}天': 'أنا استخدم SuperChinese<br />لمدة <span>{day}</span> يوم',
	'学习生词': 'تعلم الكلمات الجديدة',
	'学习语法': 'تعلم القواعد',
	'口语练习': 'التدريب الشفهي',
	'{n}个': '<span>{n}</span>',
	'{n}次': 'لــ <span>{n}</span> مرة',
	'点击右上角的按钮,选择在浏览器中打开': 'انقر فوق الزر في الزاوية اليمنى العليا واختر فتح في المتصفح',
	'邀请码': 'رمز الدعوة',
	'用邀请码注册，参与抽大奖': 'ادعُ مستخدمين جدد للتسجيل واملأ رمز الدعوة للمشاركة في السحب على الجوائز.',
}
export default ar;